import { makeStyles } from '@material-ui/core/styles';

export const styles = {
  card: {
    margin: '10px',
  },
  formControl: {
    margin: '10px',
    width: '250px',
  },
  title: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '18px',
    fontWeight: 'bold',
    color: 'black',
  },
};

const useStyles = makeStyles(styles);
export { useStyles };
